import { useCallback } from "react";
import { useTolgee } from "@tolgee/react";
import { selectUser } from "api/firebase";
import { useCurrentExhibitor } from "store/current-exhibitor/current-exhibitor.store";
import { stagedLanguageStore } from "store/localization/staged-language.store";

export const useLanguageSelection = () => {
  const tolgee = useTolgee();

  return useCallback(
    (code: string) => {
      tolgee.changeLanguage(code);

      const { stage, clear } = stagedLanguageStore.getState();

      if (!selectUser()) {
        stage(code);
        return;
      }

      clear();

      const { item, setSelectedLanguage } = useCurrentExhibitor.getState();

      if (!item) return;

      setSelectedLanguage(code).catch((e) =>
        console.error("Failed to persist selected language: ", e)
      );
    },
    [tolgee]
  );
};
